import React from 'react';

import {StoreType} from "../../store/spirs/types";
import {useSelector} from "react-redux";
import {Widget} from "./statscore/Widget";

export function WidgetsPane() {
    const {widget, showWidget} = useSelector((state: StoreType) => state.spirs);
    return (
        <div className="w-full tablet:w-[320px] netbook:w-[416px] netbook:mr-[20px] bg-[#171A1E]">
            {showWidget && <Widget {...widget}/>}
        </div>
    );
}
